<template>
    <!--所属店铺下拉接口-->
    <el-select v-model="storeId" multiple value-key="storeId"  :placeholder="placeholder" :size="size"
               @visible-change="visiblechange" @change="change">
        <el-option
                v-for="item in list"
                :key="item.storeId"
                :label="item.storeName"
                :value="item">
        </el-option>
    </el-select>
</template>

<script>
    export default {
        name: "store-drop",
        props: {
            size: String,
            placeholder: String,
            required: Boolean,
            // multiple: Boolean,
            // clearable: Boolean,
            value: [Array, Object, String],
        },
        model: {
            prop: 'value',
            event: 'input'
        },
        data() {
            return {
                list: [],
                oldstoreId: [{storeName: '全部门店', storeId: 'all'}],
                storeId: [{storeName: '全部门店', storeId: 'all'}],
                multiple: false,
            }
        },
        watch: {
            value(newval, oldval) {
                console.log(newval)
                this.storeId = newval;

            }
        },
        mounted() {
            this.getData();
        },
        methods: {
            getData() {
                this.$axios.post('/store/dropDownBox').then(res => {
                    this.list = res.data.list;
                    this.list.unshift({storeName: '全部门店', storeId: 'all'});
                    this.change(this.storeId);
                }).catch(err => {
                    this.$message.error(err.msg)
                })
            },
            visiblechange(isshow) {
                console.log(isshow)
                if (isshow) {
                    this.getData();
                }
            },
            checkedList(value){
                var a = [], newval = [];
                for(var i in value){
                    console.log(1)
                    if(value[i].storeId=='all'){
                        newval=[{storeName: '全部门店', storeId: 'all'}];
                        break;
                    }
                }
                if(newval.length==0){
                    if(value.length == this.list.length - 1){
                        newval=[{storeName: '全部门店', storeId: 'all'}]
                    }else{
                        newval = value;
                    }

                }
                var a=this.list.filter((item) => item.storeId!='all');
                console.log(newval)
                this.storeId=newval;
                this.$emit('input', newval)
                this.$emit('change', a);
            },
            change(value) {
                console.log(value)
                this.checkedList(value);

            }
        }
    }
</script>

<style scoped>

</style>